<ng-container [ngSwitch]="SITE_CONFIG">
	<gls-header-ecsomag *ngSwitchCase="'ecsomag-hu'"></gls-header-ecsomag>
	<app-header *ngSwitchCase="'csomag-hu'"></app-header>
</ng-container>

<main>
	<router-outlet></router-outlet>
</main>

<app-footer></app-footer>

<router-outlet name="modal"></router-outlet>
